import getDateWithTimeZone from "helpers/getDateWithTimeZone";
import { IResearchResponce, IUserData } from "interfaces";
import { TFunction } from 'i18next';
import { ICompareDataType, IDocumentInfoData } from "../interfaces";

const infoKeys = ['name', 'owner_name', 'downloaded_at', 'initiator_name', 'document_id', 'token', 'researched_at', 'version_count'];
const dateKeys = ['downloaded_at', 'created_at', 'modified_at', 'uploaded_at', 'researched_at', 'opened_at'];
const userKeys = ['owner', 'initiator'];
const compareKeys = ['name', 'description', 'extension', 'size', 'author', 'created_at', 'modified_at', 'version', 'room_id', 'room_name', 'uploaded_at', 'opened_at', 'ip', 'browser_version' ]

const prepareDocumentInfo = (documentData: IResearchResponce, t: TFunction, userData: IUserData) => {
  const preparedInfo: any = {};  
  for (let value in documentData) {
    preparedInfo[value] = {};
    const currentObject = documentData[value as keyof typeof documentData];

    for (let key in currentObject) {
      if (dateKeys.includes(key)) {
        preparedInfo[value][key] = currentObject[key as keyof typeof currentObject] && getDateWithTimeZone(currentObject[key as keyof typeof currentObject], userData.date_format);
      } else if (userKeys.includes(key)) {
        preparedInfo[value][`${key}_name`] = (currentObject[key as keyof typeof currentObject] as any)?.name;

      } else {
        preparedInfo[value][key] = currentObject[key as keyof typeof currentObject];
      };

    };
  };

  const infoData: ICompareDataType[] = [];
  const infoCompare: ICompareDataType[] = [];

  const addRowToInfoData = (key: string) => {
    infoData.push({
      key: t(`Report.info.${key}`),
      current: preparedInfo.current[key as keyof typeof preparedInfo.current] || 0,
      previous: preparedInfo.previous[key as keyof typeof preparedInfo.previous] || 0
    });
  };

  const addRowToInfoCompare = (key: string) => {
    infoCompare.push({
      key: t(`Report.info.${key}`),
      current: preparedInfo.current[key as keyof typeof preparedInfo.current],
      previous: preparedInfo.previous[key as keyof typeof preparedInfo.previous]
    });
  };

  infoKeys.forEach(key => {
    addRowToInfoData(key);
  });

  compareKeys.forEach(key => {
    addRowToInfoCompare(key);
  });

  infoData.push({
    key: t(`Report.info.current_user`),
    current: `${userData.first_name} ${userData.last_name}`,
    previous: `${userData.first_name} ${userData.last_name}`,
  })
  
  const documentInfoData: IDocumentInfoData = {
    uploadInfo: [],
    downloadInfo: [],
    signatureInfo: []
  };

  if (documentData.previous) {
    const uploadDate = preparedInfo.previous.uploaded_at;
    const roomName = preparedInfo.previous.room_name;
    const ownerName = documentData.previous.owner?.name;
    const ownerEmail = documentData.previous.owner?.email;
    const ip = preparedInfo.previous.ip;
    const browserVersion = preparedInfo.previous.browser_version;

    documentInfoData.uploadInfo = [
      { key: t('Report.info.dateTime'), value: uploadDate || '-' },
      { key: t('Report.info.room'), value: roomName || '-' },
      { key: t('Report.info.user'), value: ownerName && ownerEmail ? `${ownerName} ${ownerEmail}` : '-' },
      { key: t('Report.info.ipBrowserDevice'), value: ip && browserVersion ? `IP ${ip} ${t('Report.info.browser_version')} ${browserVersion}` : '-' }
    ];
  }

  if (documentData.previous) {
    const downloadDate = preparedInfo.previous.downloaded_at;
    const roomName = preparedInfo.previous.room_name;
    const initiatorName = documentData.previous.initiator?.name;
    const initiatorEmail = documentData.previous.initiator?.email;
    const ip = preparedInfo.previous.ip;
    const browserVersion = preparedInfo.previous.browser_version;

    documentInfoData.downloadInfo = [
      { key: t('Report.info.dateTime'), value: downloadDate || '-' },
      { key: t('Report.info.room'), value: roomName || '-' },
      { key: t('Report.info.user'), value: initiatorName && initiatorEmail ? `${initiatorName} ${initiatorEmail}` : '-' },
      { key: t('Report.info.ipBrowserDevice'), value: ip && browserVersion ? `IP ${ip} ${t('Report.info.browser_version')} ${browserVersion}` : '-' }
    ];
  }

  documentInfoData.signatureInfo = [
    { key: t('Report.info.status'), value: t('Report.info.absent') }
  ];

  return {
    infoData,
    infoCompare,
    documentInfoData
  };
}

export default prepareDocumentInfo
